import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent23: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Show that dogs will eat the dog food</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Show that dogs will eat the dog food
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step, you will take your Minimum Viable Business Product (MVBP), put it in front of your target customer, and test whether this integrated system of assumptions will be accepted and paid for by your target customer, thus showing that your individual assumptions when assembled together actually work in the real world.

You should demonstrate quantitatively that customers will pay for your MVBP (the price is not relevant at this point), and you should also develop metrics that indicate the level of word of mouth your MVBP is creating among customers.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Collect and analyze purchasing and WOM data
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  Even if the dogs do not eat nearly as much dog food as you thought, you can now learn a tremendous amount because you have real data on the MVBP. You are now in an iterative learning feedback loop with your customer, which is where you will start to mine the gold that will make you rich—customer preferences. With today’s tools, there are so many ways to measure if the dogs are eating the dog food, so entrepreneurs should take full advantage of these tools.

The target customer buys and accepts the product. The initial price of the product is not as important as showing that target customers will pay for the adoption of your product.
Define metrics to measure how much customers will advocate to others in the TAM about the benefits of your product (the magnitude of the positive word of mouth your product is generating—often referred to as the virality coefficient).
Monitor these metrics over time (this creates valuable word of mouth that will decrease your Cost of Customer Acquisition).
Look for trends and understand underlying drivers. Make sure you are intellectually honest and rely on real-world data and not abstract logic.
Decide whether this new information impacts on the product or business model, and make a list of necessary changes or improvements before moving on to the next steps. If needed, revisit previous steps.
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent23 };
